module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name-title"
  }, [_c('div', {
    ref: "titleContainer",
    staticClass: "name-title__title-container"
  }, [_c('div', {
    staticClass: "name-title__main-container"
  }, [_c('div', {
    ref: "title",
    staticClass: "name-title__title"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    ref: "square",
    staticClass: "name-title__square"
  })]), _vm._v(" "), _c('div', {
    ref: "subtitle",
    staticClass: "name-title__subtitle"
  }, [_vm._v(_vm._s(_vm.subtitle))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d08ed304!./~/vue-loader/lib/selector.js?type=template&index=0!./src/spa/Home/HomeTitle.vue
// module id = 281
// module chunks = 0